// Sportpacks Redesign - (c) 2026 NextPercent, nextpercent.de
// Lizenziert ausschliesslich fuer sport-packs.myshopify.com.
// Einsatz in weiteren Shops nur mit schriftlicher Genehmigung: info@nextpercent.de
// Mobile browser bars and keyboards resize the viewport while scrolling.
// Keep the initial hero height until the layout width actually changes.
(() => {
  let width, frame;
  function measure() {
    frame = null;
    const nextWidth = window.innerWidth;
    if (nextWidth === width) return;
    width = nextWidth;
    document.querySelectorAll('.sp-hero__grid').forEach(hero => {
      hero.style.removeProperty('--sp-mobile-hero-height');
      if (width > 749) return;
      const height = hero.getBoundingClientRect().height;
      if (height > 0) hero.style.setProperty('--sp-mobile-hero-height', `${height}px`);
    });
  }
  window.addEventListener('resize', () => {
    if (!frame) frame = requestAnimationFrame(measure);
  }, { passive: true });
  document.addEventListener('shopify:section:load', () => { width = undefined; measure(); });
  measure();
})();
